export default __webpack_public_path__ + "static/media/ic-home-logout.851ece19.svg";